export default "__VITE_ASSET__0FJ2pXZB__"